import splashScreenImage from "../../assets/images/karo-splash-img.png";
import "./splash-screen.scss";

export const SplashScreen = () => {
	return (
		<div className="splash-screen-holder">
			<div className="splash-screen">
				<img
					src={splashScreenImage}
					alt="karo-splash-logo"
					className="img-fluid"
					style={{ maxWidth: "130px" }}
				/>
			</div>
		</div>
	);
};
